import Vue from "vue"
import VueRouter from "vue-router"
import firebase from "firebase/app"

Vue.use(VueRouter)

const routes = [
  // redirects
  {
    path: "*",
    redirect: "/auth"
  },

  // main section
  {
    path: "/",
    name: "home",
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "home" */
        "@/views/index.vue"
      )
  },

  // auth section
  {
    path: "/auth",
    name: "auth",
    meta: {
      layout: "empty",
      requiresAuth: false
    },
    component: () =>
      import(
        /* webpackChunkName: "auth" */
        "@/views/auth/index.vue"
      )
  },
  {
    path: "/auth/new-user",
    name: "new-user",
    meta: {
      layout: "empty"
    },
    component: () =>
      import(
        /* webpackChunkName: "new-user" */
        "@/views/auth/new-user.vue"
      )
  },
  {
    path: "/auth/gen-org",
    name: "gen-org",
    meta: {
      layout: "empty"
    },
    component: () =>
      import(
        /* webpackChunkName: "gen-org" */
        "@/views/auth/gen-org.vue"
      )
  },
  {
    path: "/auth/first-integration",
    name: "first-integration",
    meta: {
      layout: "empty"
    },
    component: () =>
      import(
        /* webpackChunkName: "first-integration" */
        "@/views/auth/first-integration.vue"
      )
  },

  // payments section
  {
    path: "/payments",
    name: "payments",
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "payments" */
        "@/views/payments/index.vue"
      )
  },
  {
    path: "/payments/fail",
    name: "payments-fail",
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "payments-fail" */
        "@/views/payments/fail.vue"
      )
  },
  {
    path: "/payments/success",
    name: "payments-success",
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "payments-success" */
        "@/views/payments/success.vue"
      )
  },
  {
    path: "/integrations",
    name: "integrations",
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "integrations" */
        "@/views/integrations/index.vue"
      )
  },
  {
    path: "/integrations/oauth-grant-access",
    name: "integrations-oauth-grant-access",
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "integrations-grant-access" */
        "@/views/integrations/oauth-grant-access.vue"
      )
  },
  {
    path: "/auth/cb/salesforce",
    name: "sacb",
    meta: {
      layout: "empty"
    },
    component: () =>
      import(
        /* webpackChunkName: "sacb" */
        "@/views/auth/cb/salesforce.vue"
      )
  },
  {
    path: "/auth/cb/hubspot",
    name: "hacb",
    meta: {
      layout: "empty"
    },
    component: () =>
      import(
        /* webpackChunkName: "sacb" */
        "@/views/auth/cb/hubspot.vue"
      )
  },
  {
    path: "/auth/cb/email-signup",
    name: "emcb",
    meta: {
      layout: "empty",
      requiresAuth: false
    },
    component: () =>
      import(
        /* webpackChunkName: "sacb" */
        "@/views/auth/cb/email-signup.vue"
      )
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

// handle auth verification
router.beforeEach(async (to, from, next) => {
  // get current user
  const currentUser = firebase.auth().currentUser

  // pull meta tag
  const requiresAuth = to.matched.some((record) => {
    const meta = (record.meta || {}).requiresAuth
    return meta === false ? false : true
  })

  // redirect
  if (requiresAuth && !currentUser) next("/auth")
  else if (!requiresAuth && currentUser) next("/")
  else next()
})

export default router
